module.exports = __webpack_public_path__ + "img/no_result.3b61ac39.png";